import React from 'react';

export interface DrawContextProps {
    readonly preserveAspectRatio: string;
}

export const DrawContext = React.createContext<DrawContextProps>({
    preserveAspectRatio: "xMidYMid slice",
});


